import React, { FC } from 'react';
import InlineMessage from '@ingka/inline-message';

const AddSolutionsBanner: FC = () => {
  return (
    <InlineMessage
      title={'Required information is missing'}
      body={'You need to add at least one solution'}
      variant={'negative'}
    />
  );
};

export default AddSolutionsBanner;
